import { nb } from 'date-fns/locale/nb';

import { format, getZonedDate } from '@eika-infrastruktur/date';

export const formatLastLoginTime = (dateTime: string | undefined): string => {
    const lastLoginTime = getZonedDate(dateTime, {
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    });

    const now = getZonedDate(undefined, { timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone });
    if (
        lastLoginTime.getFullYear() === now.getFullYear() &&
        lastLoginTime.getMonth() === now.getMonth() &&
        lastLoginTime.getDate() === now.getDate()
    ) {
        return format(lastLoginTime, "' i dag kl.' HH.mm", nb);
    }

    if (lastLoginTime.getFullYear() === now.getFullYear() && lastLoginTime.getMonth() === now.getMonth()) {
        return format(lastLoginTime, ": d. MMMM 'kl.' HH.mm", nb);
    }

    return format(lastLoginTime, ": d. MMMM yyyy 'kl.' HH.mm", nb);
};
